module.exports = __webpack_public_path__ + "static/media/biiiiizlo000ogo.9936cef1.png";